// Primitive 1 — Button.
// Un seul bouton `primary` par écran. Toute action est un <button> ou
// un <a>, jamais un <div onClick> : c'est la règle 7 des erreurs d'AGC
// qu'on ne refait pas.

export function Button({
  variant = 'secondary',
  size,
  block = false,
  icon = false,
  type = 'button',
  className = '',
  children,
  ...props
}) {
  const classes = [
    'btn',
    `btn--${variant}`,
    size === 'sm' && 'btn--sm',
    block && 'btn--block',
    icon && 'btn--icon',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...props}>
      {children}
    </button>
  );
}

export default Button;
